var _path, _path2, _path3, _path4, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCreditInOut = function SvgCreditInOut(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73048 11.4567L3.49607 8.91556L5.73048 6.37447M3.49607 8.91556H8.85867H3.49607Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.599976 0.600006V0.600006C1.17987 0.600006 1.64998 1.07011 1.64998 1.65001V16.35C1.64998 16.9299 1.17987 17.4 0.599976 17.4V17.4",
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3999 3.1846H12.926M17.3999 13.5231H11.8464C10.8542 13.5231 10.0499 12.7187 10.0499 11.7265V6.87691M12.926 3.1846H11.8464C10.8542 3.1846 10.0499 3.98894 10.0499 4.98114V6.87691M12.926 3.1846C13.0325 4.29229 12.6064 6.58152 10.0499 6.87691",
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1797 13.5231C13.3101 12.8338 12.8667 11.352 10.0498 10.9385",
    stroke: "currentColor",
    strokeWidth: 0.89827
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3993 10.8119C16.3597 10.8114 15.5171 9.9267 15.5171 8.83548C15.5171 7.74426 16.3597 6.85958 17.3993 6.85901V7.75728C16.8961 7.75787 16.4153 8.19904 16.4153 8.83548C16.4153 9.47192 16.8961 9.91309 17.3993 9.91368V10.8119Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditInOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "assets/images/creditInOut.svg";
export { ForwardRef as ReactComponent };